import { render, staticRenderFns } from "./ItsStockFruitOutBoundDetail.vue?vue&type=template&id=27a4331a&scoped=true&"
import script from "./ItsStockFruitOutBoundDetail.vue?vue&type=script&lang=js&"
export * from "./ItsStockFruitOutBoundDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsStockFruitOutBoundDetail.vue?vue&type=style&index=0&id=27a4331a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a4331a",
  null
  
)

export default component.exports